import React, { useEffect, useState } from 'react';
import { LandingPage } from './pages/LandingPage';
import { LoginPage } from './pages/LoginPage';
import { MainApp } from './pages/MainApp';
import { TermsOfService } from './pages/TermsOfService';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { Disclaimers } from './pages/Disclaimers';
export function App() {
  // Simple state-based router
  const [currentPage, setCurrentPage] = useState('landing');
  // Handle browser back/forward buttons
  useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      if (event.state?.page) {
        setCurrentPage(event.state.page);
      }
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);
  const navigate = (page: string) => {
    setCurrentPage(page);
    window.history.pushState({
      page
    }, '', `#${page}`);
    // Scroll to top on navigation
    window.scrollTo(0, 0);
  };
  // Check initial hash
  useEffect(() => {
    const hash = window.location.hash.replace('#', '');
    if (hash && ['landing', 'login', 'app', 'terms', 'privacy', 'disclaimers'].includes(hash)) {
      setCurrentPage(hash);
    }
  }, []);
  return <>
      {currentPage === 'landing' && <LandingPage onNavigate={navigate} data-id="element-0" />}
      {currentPage === 'login' && <LoginPage onNavigate={navigate} data-id="element-1" />}
      {currentPage === 'app' && <MainApp onNavigate={navigate} data-id="element-2" />}
      {currentPage === 'terms' && <TermsOfService onNavigate={navigate} data-id="element-3" />}
      {currentPage === 'privacy' && <PrivacyPolicy onNavigate={navigate} data-id="element-4" />}
      {currentPage === 'disclaimers' && <Disclaimers onNavigate={navigate} data-id="element-5" />}
    </>;
}